export const AttachmentListItem = {
  renaming: false,
  dummyNameSetup: false,
  renameButtonSetup: false,

  mounted() {
    this.setup()

    this.el.addEventListener("mouseleave", () => {
      const dropdown = this.el.querySelector(".dropdown")
      if (dropdown) dropdown.classList.add("hidden")
    })
  },

  updated() {
    this.setup()
  },

  setup() {
    this.fileIdInput = this.el.querySelector(".file-id")
    this.fileNameInput = this.el.querySelector(".file-name")
    this.fileTitle = this.el.querySelector(".data-set-title")
    this.renameWrapper = this.el.querySelector(".rename-wrapper")

    this.dummyNameInput = this.el.querySelector(".data-set-input")
    this.renameButton = this.el.querySelector(".rename-button")

    if (this.dummyNameInput && !this.dummyNameSetup) {
      this.dummyNameInput.addEventListener("change", (event) => {
        event.stopPropagation()
      })

      this.dummyNameInput.addEventListener("input", (event) => {
        event.stopPropagation()
      })

      this.dummyNameInput.addEventListener("keydown", (event) => {
        if (event.key === "Enter") {
          event.preventDefault()
          event.stopPropagation()

          this.fileNameInput.value = this.dummyNameInput.value
          this.fileNameInput.dispatchEvent(
            new Event("input", { bubbles: true }),
          )
          this.renaming = false
          this.hideShowControls()
        } else if (event.key === "Escape") {
          this.dummyNameInput.value = this.fileNameInput.value
          this.renaming = false
          this.hideShowControls()
        }
      })

      this.dummyNameSetup = true
    }

    if (this.renameButton && !this.renameButtonSetup) {
      this.renameButton?.addEventListener("click", (event) => {
        this.renaming = true

        this.hideShowControls()

        this.dummyNameInput.value = this.fileNameInput.value
        this.dummyNameInput.focus()
        this.dummyNameInput.setSelectionRange(
          0,
          this.dummyNameInput.value.length,
        )
      })

      this.renameButtonSetup = true
    }

    if (this.el.dataset.saveNew == "true" && !this.el.dataset.attachmentId) {
      this.fileIdInput.dispatchEvent(new Event("input", { bubbles: true }))
    }

    if (this.el.dataset.attachmentId) {
      this.renameButton.classList.remove("hidden")
    }

    this.hideShowControls()
  },

  hideShowControls() {
    if (this.renaming) {
      this.renameWrapper?.classList.remove("hidden")
      this.fileTitle.classList.add("hidden")
    } else {
      this.renameWrapper?.classList.add("hidden")
      this.fileTitle.classList.remove("hidden")
    }
  },
}
